/**
 * Helpers de coordenada compartilhados pelo mapa de ponto único (LocationMap) e
 * pelos formulários que o alimentam (cadastro de Local, contrato). Centraliza o
 * parse tolerante do campo de texto, a faixa válida e o link do Google Maps, para
 * a mesma regra valer no marcador, na validação do form e no botão externo.
 */

/** Precisão de `Numeric(9,6)` no banco — arredonda antes de devolver ao form. */
export const COORD_DECIMALS = 6
export const roundCoord = (n: number): number => Number(n.toFixed(COORD_DECIMALS))

/** String do input → número, ou null quando vazia/incompleta/inválida. Durante a
 *  digitação o campo passa por estados intermediários ("-", ".", "12,") que não
 *  podem quebrar o mapa; todos viram null até o valor ficar completo. Aceita
 *  vírgula ou ponto como separador decimal (padrão de entrada pt-BR). */
export function parseCoord(value: unknown): number | null {
  if (value == null) return null
  const s = String(value).trim().replace(',', '.')
  if (s === '' || s === '-' || s === '.' || s === '-.') return null
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

export const isValidLatitude = (n: number | null | undefined): n is number =>
  n != null && Number.isFinite(n) && n >= -90 && n <= 90
export const isValidLongitude = (n: number | null | undefined): n is number =>
  n != null && Number.isFinite(n) && n >= -180 && n <= 180

/** Par de coordenadas dentro da faixa geográfica → pode posicionar o marcador. Não
 *  aplica o veto à Ilha Nula (0,0): isso é regra de validação do form, não do mapa. */
export function isInRangeLatLng(lat: number | null | undefined, lng: number | null | undefined): boolean {
  return isValidLatitude(lat) && isValidLongitude(lng)
}

/** 0,0 no Atlântico: quase sempre fruto de erro (nunca um local no Brasil). Usado
 *  só na validação do formulário para não aceitar a coordenada silenciosamente. */
export const isNullIsland = (lat: number | null | undefined, lng: number | null | undefined): boolean =>
  lat === 0 && lng === 0

/** Link do Google Maps para as coordenadas (abre em nova aba). */
export const googleMapsUrl = (lat: number, lng: number): string =>
  `https://www.google.com/maps?q=${lat},${lng}`
